const translates = {
	en: {
		modalTitle: 'Добавить инструментальные исследования'
	},
	ru: {
		modalTitle: 'Add instrumental data'
	}
};
export default translates;